import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { LoyaltyOffer } from "../../types/modules/admin/loyaltyOffer.type";

interface UseParams {
  page?: number;
  limit?: number;
}
export const useLoyaltyOffersByAdmin = ({
  page = 1,
  limit = 10,
}: UseParams) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  return useQuery({
    queryKey: ["loyalty-offers-by-admin"],
    queryFn: () =>
      fetcher<{ data: LoyaltyOffer[]; totalPages: number; total: number }>(
        `loyalty-offer/admin?${queryParams.toString()}`,
        token
      ),
  });
};
